"use strict";

module.exports = {
  // a selection of commonly traded, stable currencies
  USD: {
    code: 'USD',
    symbol: '$',
    formatDecimalSeperator: '.',
    formatThousandsSeperator: ',',
    formatDefaultDecimals: 2,
    formatString: '-¤#'
  },
  EUR: {
    code: 'EUR',
    symbol: '€',
    formatDecimalSeperator: '.',
    formatThousandsSeperator: ',',
    formatDefaultDecimals: 2,
    formatString: '-¤#'
  },
  JPY: {
    code: 'JPY',
    symbol: '¥',
    formatDecimalSeperator: '.',
    formatThousandsSeperator: ',',
    formatDefaultDecimals: 0,
    formatString: '-¤#'
  },
  GBP: {
    code: 'GBP',
    symbol: '£',
    formatDecimalSeperator: '.',
    formatThousandsSeperator: ',',
    formatDefaultDecimals: 2,
    formatString: '-¤#'
  },
  CHF: {
    code: 'CHF',
    symbol: 'CHF',
    formatDecimalSeperator: '.',
    formatThousandsSeperator: "'",
    formatDefaultDecimals: 2,
    formatString: '-¤#'
  },
  AUD: {
    code: 'AUD',
    symbol: 'AUD$',
    formatDecimalSeperator: '.',
    formatThousandsSeperator: ' ',
    formatDefaultDecimals: 2,
    formatString: '-¤#'
  },
  CAD: {
    code: 'CAD',
    symbol: 'CAD$',
    formatDecimalSeperator: '.',
    formatThousandsSeperator: ',',
    formatDefaultDecimals: 2,
    formatString: '-¤#'
  }
};
